import "bootstrap/js/src/collapse";
import init from "./Modules/init.js";

//SCSS
import "../Scss/style.scss";

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init.init);
} else {
    init.init();
}
